import React, { useMemo, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ValidationOptions } from 'react-hook-form/dist/types';
import { validateRequired } from 'utils/form';
import { CustomRadio, CustomRadioProps } from './CustomRadio';
import './radioButton.styles.scss';

interface CustomRadioFieldProps extends CustomRadioProps {
	validation?: ValidationOptions;
}

export const CustomRadioField: React.FC<CustomRadioFieldProps> = ({
	validation = {},
	required,
	name,
	onChange,
	children,
	value,
	...props
}) => {
	const { register, watch, unregister } = useFormContext();
	const { t } = useTranslation('errors');

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (onChange) {
			onChange(e);
		}
	};
	const watchActiveValue = watch(name);

	const isChecked = useMemo(() => value === watchActiveValue, [
		value,
		watchActiveValue,
	]);

	useEffect(() => {
		return () => {
			unregister(name);
		};
	}, [unregister, name]);

	return (
		<CustomRadio
			name={name}
			value={value}
			onChange={handleChange}
			checked={isChecked}
			ref={register({
				...validateRequired(required, t('required')),
				...validation,
			})}
			formField
			{...props}
		>
			{children}
		</CustomRadio>
	);
};
